/* eslint-disable import/prefer-default-export */
export const SET_QUESTION_FEEDBACK = 'SET_QUESTION_FEEDBACK';
